// ⚠️ AUTO-GENERATED — DO NOT EDIT MANUALLY
// Source: ./svg/IconFileTxt.svg — regenerate with `nx run creditflowresearch-uilib:icons-generate --write`
import BaseIcon from './BaseIcon';
import type { IIconProps } from './types';

const IconFileTxt = (props: IIconProps) => (
  <BaseIcon viewBox="0 0 16 16" fill="currentColor" { ...props }>
    <path fillRule="evenodd" clipRule="evenodd" d="M3.59951 0H9.99951L14.7995 4.8V7H1.99951V1.6C1.99951 0.72 2.71951 0 3.59951 0ZM9.19951 5.6H13.5995L9.19951 1.2V5.6Z" />
    <path fillRule="evenodd" clipRule="evenodd" d="M0 8H16V16H0V8ZM4.5483 10.1168H6.06928V9H1.8335V10.1168H3.32664V15H4.5483V10.1168ZM9.1636 9L8.33524 10.9945L7.50687 9H6.11467L7.52776 11.9753L6.07638 15H7.48251L8.33524 12.9684L9.18796 15H10.5976L9.14272 11.9753L10.5593 9H9.1636ZM14.8335 10.1168H13.3125V15H12.0909V10.1168H10.5977V9H14.8335V10.1168Z" />
  </BaseIcon>
);

export default IconFileTxt;
